export { default as ClientDetailsPage } from './ClientDetails';
export { default as LocationDetailsPage } from './LocationDetails';
